import React from 'react';
import './App.css';
import { Button, Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import AnimatedCursor from "react-animated-cursor";
import logo from "./img/logo.png";
import shopping from "./img/shopping-bag.svg";
import banner_data from "./banner_data";
import BestItem from "./BestItem";
import Resizable from "./Slider";
import category_data from "./category_data";
import {Category_data} from "./category_data"
import newbox_data from "./newbox_data";
import {Newbox_data} from "./newbox_data"
import shipping from "./img/shipping.png";
import trend_main_img from "./img/trend/trend_main.jpg";
import trend_data_1 from "./trend_data_1";
import {Trend_data1} from "./trend_data_1"
import trend_data_2 from "./trend_data_2";
import {Trend_data2} from "./trend_data_2"
import SpcPrice from "./SpcPrice";
import season_data from "./season_data";
import { Season_data } from "./season_data"
import axios from "axios";
import Detail from './Detail';
import all_data from "./all_data";
import { All_data } from "./all_data"
import Cart from './Cart'
import Hamburger from 'hamburger-react';

interface Trend1Props {
  a : Trend_data1;
}

interface Trend2Props {
  a : Trend_data2;
}

interface NewboxProps {
  a : Newbox_data;

  res1 : number[];

  i : number;
}

interface CategoryProps {

  category_data: Category_data[];

  res2 : number[];
}

interface SeasonProps {
  a : Season_data
}

function App(): JSX.Element {
  let navigate = useNavigate();

  let [all] = useState<All_data[]>(all_data);

  let [season, setSeason] = useState<Season_data[]>(season_data);

  let [count, setCount] = useState<number>(1);

  let [res1, setRes1] = useState<number[]>([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);

  let [res2, setRes2] = useState<number[]>([1, 2, 9, 25, 16, 19, 18, 0]);

  let [modal2, setModal] = useState<boolean>(false);


  return (
    <div className="App">
      <nav className="top-nav">
        <Nav.Link href="/login">로그인</Nav.Link>
        <Nav.Link href="/join">회원가입</Nav.Link>
        <Nav.Link href="/inquiry">주문조회</Nav.Link>
        <Nav.Link href="/Q&A">Q&A</Nav.Link>
      </nav>

      <nav className="bot-nav">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>
        <nav className="main-nav">
          <div>
            <Nav.Link onClick={() => { navigate('/detail/0') }}>BEST</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/1') }} className="new">
              NEW
            </Nav.Link>
          </div>
          <div>
            <Nav.Link onClick={() => { navigate('/detail/2') }}>패키지</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/3') }}>T-shirts</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/4') }}>Bottom</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/5') }}>Shirts</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/6') }}>Denim</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/7') }}>Acc</Nav.Link>
          </div>
          <div className="bot_nav_shipping">
            <Nav.Link onClick={() => { navigate('/detail/8') }}>예약배송</Nav.Link>
            <Nav.Link onClick={() => { navigate('/detail/9') }}>뚝딱배송</Nav.Link>
            <NavDropdown
              title="세일"
              id="basic-nav-dropdown"
              className="new2"
            >
              <NavDropdown.Item onClick={() => { navigate('/detail/10') }}>
                올데이-세일 ~30%
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => { navigate('/detail/11') }}>
                쎄굿빠-세일 ~75%
              </NavDropdown.Item>
            </NavDropdown>
          </div>
          <input type="text" className="sertch" maxLength={10} />
          <Link to="/Cart">
            <i className="fa-solid fa-magnifying-glass" id="glass" onClick = {() => {
              window.scrollTo(0, 0);
            }}></i>
          </Link>
          <div className="Cartbtn">
            <Link to="/Cart">
              <img src={shopping} onClick = { () => {
                window.scrollTo(0, 0);
              }}/>
            </Link>
          </div>
          <div
              className="menubtn"
              onClick={() => {
                setModal(!modal2);
              }}
            >
              <Hamburger direction="right" size={24}/>
            </div>
            {modal2 == true ? <PopupModal /> : null}
        </nav>
      </nav>

      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Resizable />

              <Title1 />

              <Category category_data={category_data} res2={res2} />

              <div className="banner">
                {banner_data.map((a, i) => {
                  return (
                    <Link to="">
                      <img src={a.imgurl} />
                    </Link>
                  );
                })}
              </div>

              <Title2 />

              <ul className="newplus">
                {newbox_data.map((a:Newbox_data, i:number) => {
                  return <Newbox a={a} res1={res1} i={i} />;
                })}
              </ul>

              <Title3 />

              <BestItem />

              <Title4 />

              <div className="trend_wrap">
                <div className="trend_item_list">
                  {trend_data_1.map((a:Trend_data1, i:number) => {
                    return <Trendbox1 a={a} />;
                  })}
                </div>
                <div className="trend_item_list">
                  <Link to="detail/">
                    <img src={trend_main_img} />
                    <div className="trend_txt_box">
                      <h3>꾸안꾸 포인트룩! :)</h3>
                      <p>with 빠짐없이 예쁜 컬러감</p>
                    </div>
                  </Link>
                </div>
                <div className="trend_item_list">
                  {trend_data_2.map((a:Trend_data2, i:number) => {
                    return <Trendbox2 a={a} />;
                  })}
                </div>
              </div>

              <div className="spc_wrap">
                <Title5 />

                <SpcPrice />
              </div>

              <div className="season_wrap">
                <Title6 />
                <ul className="season_ul">
                  {season.map((a:Season_data, i:number) => {
                    return <Seasonbox a={a} key={i} />;
                  })}
                </ul>
                <Button
                  variant="outline-info"
                  onClick={() => {
                    if (count == 1) {
                      axios
                        .get<Season_data[] >(
                          "https://appcoding-ux.github.io/react-data/season_data_1.json"
                        )
                        .then((result) => {
                          let copy10:Season_data[] = [...season, ...result.data];
                          setSeason(copy10);
                          console.log(copy10);
                          setCount(2);
                        });
                    } else if (count == 2) {
                      axios
                        .get<Season_data[] >(
                          "https://appcoding-ux.github.io/react-data/season_data_2.json"
                        )
                        .then((result) => {
                          let copy11:Season_data[] = [...season, ...result.data];
                          setSeason(copy11);
                          console.log(copy11);
                          setCount(3);
                        });
                    } else if (count == 3) {
                      axios
                        .get<Season_data[] >(
                          "https://appcoding-ux.github.io/react-data/season_data_3.json"
                        )
                        .then((result) => {
                          let copy12:Season_data[] = [...season, ...result.data];
                          console.log(copy12);
                          setSeason(copy12);
                          setCount(4);
                        });
                    }

                    if (count === 4) {
                      alert("더이상 상품이 없습니다.");
                    }
                  }}
                >
                  {" "}
                  + 5개 상품 더 보기{" "}
                </Button>{" "}
              </div>

              <div className="footer_banafit">
                <ul>
                  <li>
                    <h3>회원혜택</h3>
                  </li>
                  <li>
                    <span>
                      <img src="/types/img/member/img0.png" />
                    </span>
                    <p>
                      가입즉시
                      <br />
                      웰컴쿠폰 1100원
                    </p>
                  </li>
                  <li>
                    <span>
                      <img src="/types/img/member/img1.png" />
                    </span>
                    <p>
                      가입즉시
                      <br />
                      전제품 무료배송
                    </p>
                  </li>
                  <li>
                    <span>
                      <img src="/types/img/member/img2.png" />
                    </span>
                    <p>
                      회원등급별
                      <br />
                      최대20% 할인
                    </p>
                  </li>
                  <li>
                    <span>
                      <img src="/types/img/member/img3.png" />
                    </span>
                    <p>
                      APP다운시
                      <br />
                      감사쿠폰 1000원
                    </p>
                  </li>
                  <li>
                    <span>
                      <img src="/types/img/member/img4.png" />
                    </span>
                    <p>
                      생일기념
                      <br />
                      축하쿠폰 1000원
                    </p>
                  </li>
                  <li>
                    <Link to="">회원등급 혜택</Link>
                  </li>
                </ul>
              </div>
            </div>
          }
        />
        <Route path="detail/:id" element={<Detail all={all} />} />
        <Route path="cart" element={<Cart />} />
        <Route path="about" element={<div>
          <div className="about_wrap">
            <div className="about_title">
              <h2>ABOUT US</h2>
            </div>
            <ul>
              <li><img src="/types/img/about/img0.jpg" /></li>
              <li><img src="/types/img/about/img1.jpg" /></li>
              <li><img src="/types/img/about/img2.jpg" /></li>
              <li><img src="/types/img/about/img3.jpg" /></li>
            </ul>
          </div>
        </div>} />
      </Routes>

      <Footer />

      <AnimatedCursor
        innerSize={8}
        outerSize={8}
        color="133, 129, 214"
        outerAlpha={0.3}
        innerScale={0.7}
        outerScale={5}
        clickables={[
          "a",
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          "label[for]",
          "select",
          "textarea",
          "button",
          ".link",
        ]}
      />
    </div>
  );
}

function Category(props:CategoryProps): JSX.Element {
  return (
    <ul className="cate">
      {category_data.map((a:Category_data, i:number) => {
        return (
          <li>
            <Link to={`/detail/${props.res2[i]}`}>
              <img src={a.imgurl} />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

function Newbox(props:NewboxProps): JSX.Element {
  return (
    <li className="item">
      <div className="newbox">
        <div className="newbox_img">
          <Link to={`/detail/${props.res1[props.i]}`}>
            <img src={props.a.imgurl} />
          </Link>
        </div>
        <div className="newbox_txt">
          <Link to={`/detail/${props.res1[props.i]}`}>
            <span className="reservation">{props.a.font}</span>
            {props.a.title}
          </Link>
          <ul>
            <li>
              <span className="persent">{props.a.persent}</span>
              <span className="saleprice">{props.a.saleprice}</span>
              <span className="price">{props.a.price}</span>
            </li>
            <li className="review">{props.a.review}</li>
            <li>
              <img src={shipping} />
            </li>
          </ul>
        </div>
      </div>
    </li>
  );
}

function Trendbox1(props:Trend1Props): JSX.Element {
  return (
    <div className="trend_item">
      <img src={props.a.imgurl} />

      <div className="preview_in_box">
        <Link to="">
          <span>
            <i className="fa-regular fa-heart" style={{ color: "#ffffff" }}></i>
          </span>
        </Link>
        <Link to="">
          <span>
            <i
              className="fa-regular fa-credit-card"
              style={{ color: "#ffffff" }}
            ></i>
          </span>
        </Link>
      </div>
    </div>
  );
}

function Trendbox2(props:Trend2Props): JSX.Element {
  return (
    <div className="trend_item">
      <img src={props.a.imgurl} />

      <div className="preview_in_box">
        <Link to="">
          <span>
            <i className="fa-regular fa-heart" style={{ color: "#ffffff" }}></i>
          </span>
        </Link>
        <Link to="">
          <span>
            <i
              className="fa-regular fa-credit-card"
              style={{ color: "#ffffff" }}
            ></i>
          </span>
        </Link>
      </div>
    </div>
  );
}

function Seasonbox(props:SeasonProps):JSX.Element {
  return (
    <li className="season_item">
      <img src={props.a.imgurl} />
      <div className="preview_in_box">
        <Link to="">
          <span>
            <i className="fa-regular fa-heart" style={{ color: "#ffffff" }}></i>
          </span>
        </Link>
        <Link to="">
          <span>
            <i
              className="fa-regular fa-credit-card"
              style={{ color: "#ffffff" }}
            ></i>
          </span>
        </Link>
      </div>
    </li>
  );
}

function PopupModal(): JSX.Element {
  return (
    <div className="popup_wrap">
      <div className="popup_content">
        <div className="popup_content_left">
          <ul>
            <li>TOP</li>
            <li>티셔츠</li>
            <li>셔츠</li>
            <li>스웨트셔츠</li>
            <li>후드</li>
            <li>니트</li>
          </ul>
          <ul>
            <li>BOTTOM</li>
            <li>반바지</li>
            <li>데님</li>
            <li>코튼</li>
            <li>트레이닝</li>
            <li>기타</li>
          </ul>
          <ul>
            <li>OUTWEAR</li>
            <li>집업</li>
            <li>점퍼</li>
            <li>아노락</li>
            <li>자켓&코트</li>
          </ul>
          <ul>
            <li>ACC</li>
          </ul>
          <ul>
            <li>WV스페셜</li>
            <li>데일리무지</li>
            <li>포인트 스타일</li>
            <li>데님</li>
            <li>시크블랙</li>
            <li>로맨틱 핑크</li>
          </ul>
          <ul>
            <li>뚝딱배송</li>
          </ul>
          <ul>
            <li>예약배송</li>
          </ul>
          <ul>
            <li>SALE</li>
            <li>올데이-세일</li>
            <li>쎄굿빠-세일</li>
          </ul>
        </div>
        <div className="popup_season">
          <ul>
            <li>시즌</li>
            <li>2023 S/S</li>
            <li>2023 W/S</li>
            <li>2022 F/W</li>
            <li>2022 S/S</li>
            <li>2022 W/S</li>
            <li>2021 F/W</li>
            <li>2021 S/S</li>
            <li>2021 W/S</li>
            <li>2020 F/W</li>
            <li>2020 SUMMER</li>
            <li>2020 W/S</li>
            <li>2019 F/W</li>
          </ul>
        </div>
        <div className="popup_content_right">
          <ul>
            <li>커뮤니티</li>
            <li>공지사항</li>
            <li>Q&A</li>
            <li>리뷰</li>
            <li>개인결제창</li>
          </ul>
          <ul>
            <li>ABOUT US</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function Footer():JSX.Element {
  return (
    <div className="footer_wrap">
      <div className="foot">
        <div className="foot_info1">
          <ul>
            <li><Link to="/about">회사소개</Link></li>
            <li><Link to="">이용약관</Link></li>
            <li><Link to="">개인정보처리방침</Link></li>
          </ul>
          <p>회사주소 : 서울시 동대문구 사가정로 27길 (장안동 92-2 영신빌딩 3층) 고객센터 전화 : 1644-1429</p>
          <p>사업자등록번호 : 631-87-00028 통신판매업신고 : 제2014-서울동대문-0417 상호명 : (주) 에프엠제이인터내셔날</p>
          <p>대표 : 강일훈 사업자정보확인 개인정보보호책임자 : 김기해 협찬/제휴문의 : kgnsl1@fairplay142.com</p>
          <br />
          <br />
          <p>© FMJINTERNATIONAL Corp. All rights reserved.</p>
        </div>
        <div className="foot_info2">
          <ul>
            <li><Link to="">마이페이지</Link></li>
            <li><Link to="">나의적립금</Link></li>
            <li><Link to="">공지사항</Link></li>
            <li><Link to="">문의하기</Link></li>
          </ul>
          <div>
            <p>1644-1429</p>
            <span>
            MON-FRI 10:00 ~ 17:00
            <br />
            LUNCH 13:00 ~ 14:00
            </span>
            <span>주말, 공휴일 제외</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const Title1:React.FC = ():JSX.Element => {
  return (
    <div className="category_title">
      <h2>
        <Link to="">Category</Link>
      </h2>
    </div>
  );
};

const Title2:React.FC = ():JSX.Element => {
  return (
    <div className="newtitle">
      <h2>
        <Link to="">NEW +</Link>
      </h2>
    </div>
  );
};

const Title3:React.FC = ():JSX.Element => {
  return (
    <div className="bestitem_title">
      <h2>
        <Link to="">Best Items +</Link>
      </h2>
    </div>
  );
};

const Title4:React.FC = ():JSX.Element => {
  return (
    <div className="trend_title">
      <h2>
        <Link to="">Trend</Link>
      </h2>
    </div>
  );
};

const Title5:React.FC = ():JSX.Element => {
  return (
    <div className="spc_title">
      <h2>SPECIAL PRICE</h2>
    </div>
  );
};

const Title6:React.FC = ():JSX.Element => {
  return (
    <div className="season_title">
      <h2>
        <Link to="">23 S/S season +</Link>
      </h2>
    </div>
  );
};



export default App;